<template>
  <router-link v-if="isGibangHost && linkOnly" class="gibang-pinned-notice notice-link"
    :to="{ name: 'noticeList', query: { pinned: 'gibang-rules' } }">
    <span class="notice-badge">고정 · 필독</span>
    <strong>기방 베팅규정입니다. 필독 바랍니다.</strong>
    <span aria-hidden="true"> ›</span>
  </router-link>
  <template v-else-if="isGibangHost">
    <tr class="gibang-pinned-row" data-notice="withdrawal-delay">
      <td><span class="notice-badge">공지</span></td>
      <td><button type="button" class="notice-toggle" :aria-expanded="isWithdrawalOpen" aria-controls="gibang-withdrawal-body" @click="isWithdrawalOpen = !isWithdrawalOpen">출금 시스템 점검에 따른 출금 지연 안내</button></td>
      <td>—</td>
      <td>—</td>
    </tr>
    <tr v-if="isWithdrawalOpen" class="gibang-pinned-content">
      <td colspan="4" id="gibang-withdrawal-body">
        <div class="notice-body">
          <p>안녕하세요</p>
          <p>금일 정산금 지급관련,</p>
          <p>출금가상측 시스템점검으로 인해</p>
          <p>시스템 정상화시까지</p>
          <p>출금이 지연되는점 양해말씀드리겠습니다.</p>
          <p>출금시스템 정상화시</p>
          <p>빠르게 출금진행도와드리겠습니다.</p>
          <p>이용에 불편을 드려서 대단히 죄송합니다.</p>
        </div>
      </td>
    </tr>
    <tr class="gibang-pinned-row">
      <td><span class="notice-badge">고정 · 필독</span></td>
      <td><button type="button" class="notice-toggle" :aria-expanded="isOpen" aria-controls="gibang-rules-body" @click="isOpen = !isOpen">기방 베팅규정입니다. 필독 바랍니다.</button></td>
      <td>—</td>
      <td>—</td>
    </tr>
    <tr v-if="isOpen" class="gibang-pinned-content">
      <td colspan="4" id="gibang-rules-body">
    <div class="notice-body">
      <h3>[슬롯]</h3>
      <p>1. 바닥베팅은 최대 5만원 입니다.<br>
        2. 스핀구매는 최대 300만원 입니다.<br>
        3. 최대당첨액은 5천만원 입니다.</p>

      <h3>[바카라]</h3>
      <p>1. 최대베팅은 사이드 포함하여 500만원 입니다.<br>
        2. 최대당첨은 1500만원 입니다.</p>
      <p>*퍼펙트페어는 최대 10만원까지 베팅 가능합니다.</p>

      <h3>[풍성한, 라이트닝, 익스트림 등 배수바카라]</h3>
      <p>1. 최대베팅은 수수료와 사이드 포함하여 300만원 입니다.<br>
        2. 최대당첨은 1500만원 입니다.</p>
      <p>*퍼펙트페어는 최대 10만원까지 베팅 가능합니다.</p>

      <div class="notice-warnings">
        <p><strong>초과당첨이 되시면, 초과된 당첨액은 회수합니다.</strong></p>
        <p><strong>오버베팅과 멀티베팅 적발시 보유머니 전액몰수합니다.</strong></p>
        <p><strong>양방베팅과 프로그램베팅 적발시 보유머니 전액몰수와 졸업입니다.</strong></p>
        <p><strong>로비를 통해 슬롯에 접속하여 게임을 하시면, 당첨액이 인정되지 않습니다.</strong></p>
        <p><strong>게임방에 로그인이 안되거나, 베팅이 안된다면 제한게임입니다.</strong></p>
        <p><strong>롤링 200프로 이상 채우셔야 환전이 가능합니다.</strong></p>
        <p><strong>규정에서 벗어난 베팅으로 인한 보유금 몰수와 졸업은,<br>
          사전에 공지없이 진행될 수 있으며,<br>
          이에 따른 불이익은 당사가 책임지지 않습니다.</strong></p>
      </div>
    </div>
      </td>
    </tr>
  </template>
</template>

<script>
export default {
  name: 'GibangPinnedNotice',
  props: {
    linkOnly: Boolean
  },
  data () {
    return { isOpen: this.$route.query.pinned === 'gibang-rules', isWithdrawalOpen: true }
  },
  watch: {
    '$route.query.pinned' (value) {
      this.isOpen = value === 'gibang-rules'
    }
  },
  computed: {
    isGibangHost () {
      return window.location.hostname === 'a39.gibang-111.com'
    }
  }
}
</script>

<style scoped>
.gibang-pinned-notice, .gibang-pinned-notice *, .gibang-pinned-row *, .gibang-pinned-content * { font-family: 'Malgun Gothic', 'Apple SD Gothic Neo', sans-serif; text-shadow: none; }
.gibang-pinned-notice { margin: 12px 0; border: 1px solid #dbe3ef; border-radius: 6px; background: #ffffff; color: #1f2937; text-align: left; }
.notice-link { padding: 14px; cursor: pointer; font-size: 14px; font-weight: 700; line-height: 1.6; overflow-wrap: anywhere; }
.notice-link { display: block; text-decoration: none; }
.notice-link:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
.notice-toggle:focus-visible { outline: 2px solid #2563eb; outline-offset: 2px; }
.gibang-pinned-row td { height: 43px; padding: 9px 12px; background: #f0f4ff; border-bottom: 1px solid #dfe6ef; text-align: center; vertical-align: middle; font-size: 13px; color: #1f2937; }
.notice-toggle { border: 0; padding: 0; background: transparent; color: #1f2937; font-size: inherit; font-weight: 700; line-height: 1.6; cursor: pointer; overflow-wrap: anywhere; }
.gibang-pinned-content td { padding: 0; background: #fff; border-bottom: 1px solid #dfe6ef; }
.notice-badge { display: inline-block; margin-right: 6px; color: #245ac4; }
.notice-body { padding: 4px 20px 18px; text-align: left; color: #1f2937; font-size: 14px; line-height: 1.8; overflow-wrap: anywhere; }
.notice-body h3 { margin: 20px 0 8px; font-size: 15px; font-weight: 700; color: inherit; }
.notice-body strong, .notice-link strong { font-weight: 700; }
.notice-body p { margin: 10px 0; color: inherit; font-weight: 400; }
.notice-warnings { margin-top: 24px; }
</style>
